var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex i_mt_8"},[_c('img',{attrs:{"src":_vm.resource.image}}),_c('div',{staticClass:"content i_pl_4"},[_c('h5',[_vm._v(_vm._s(_vm.resource.title))]),_c('p',{staticClass:"i_body_l"},[_vm._v(_vm._s(_vm.resource.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }